const API_ENDPOINTS = {
    // Authentication
    authLogin: `/auth/azure/authenticate`,
    authInfo: `/auth/azure/auth-info`,
    authLogout: `/app-users/logout`,

    // Policies
    authenticateDOCPolicy: `/authenticate-doc`,
    acceptPolicy: `/accept-policy`,
    acceptDOCPolicy: `/accept-doc-policy`,

    // Current User
    currentUser: `/app-users/current-user`,

    // User Management
    authorizeApps: `/authorize/apps`,
    authorizeRoles: `/authorize/roles`,
    appUsers: `/app-users`,
    authorizeMapping: `/authorize/mapping`,
    authorizeMappingUser: `/authorize/mapping/user`,

    // Chat Genie
    getUserThreads: `/fetch-user-threads`,
    getUserConversation: `/fetch-user-conversation`,
    updateUserThread: `/update-user-thread`,
    getModelList: `/models/base`,
    uploadFile: `/files/upload`,
    fileData: `/fetch-file-data`,
    textToSpeech: `/read_out_answer`,
    updateChatFeedback: `/update-feedback-chat`,
    getDocumentCitations: `/chat/doc-chunks`,
    chatCompletions: `/chat/completions`,
    fetchEnhanceQuery: `/chat/enhance-query`,
    updateProductivityFeedback: `/feedback/nps`,
    getNpsEligibility: `/feedback/nps-eligibility`,
    prompts: `/prompts`,
    updateWebSearchConsent: `/chat/web-search-consent`,
    imageToolEnhancePrompt: `/image-tool/enhance-prompt`,

    // Product Label AI
    productLabelAIChatCompletions: `/chat/completions`,
    fetchProductLabelFileData: `/citations/fetch-file-data`,

    // Excel Analysis
    chatExcelCompletions: `/query`,
    chatExcelFileUpload: `/upload`,

    // HR Assistant
    hrBotCompletions: `/hrbot/completions`,

    // Procurement
    procurementCreateSession: `/create_session`,
    procurementProgressTracker: `/progress`,
    procurementChartStatus: `/chart-status`,
    procurementChatCompletions: `/chat`,
    procurementFeedback: `/feedback`,
    getProcurementHistoryList: `/user_sessions`,
    getProcurementChatConversation: `/get_history`,
    deleteProcurementUserThread: `/delete-session`,
    renameProcurementUserThread: `/rename-session`,
    procurementTemplatePrompts: `/template`,
    procurementTemplateOptions: `/template_options`,

    // Translations
    translationText: `/translate_text`,
    translationDocs: `/translate`,
    getTranslationFileStatus: `/get_status`,
    translationFeedback: `/give_feedback`,
    translateHistory: `/get_history`,
    getTranslatedFile: `/get_file_bytes`,
    getTranslationLanguage: `/get_languages`,

    // GMT
    getGMTHistoryList: `/session/list`,
    GMTSessionId: `/session`,
    getGMTChatConversation: `/conversation`,
    updateGMTFeedback: `/feedback`,
    GMTChatCompletions: `/chat`,
    GMTChatFeedback: `/feedback`,
    deleteGMTUserThread: `/session/delete`,
    renameGMTUserThread: `/session/rename`,

    // Deep Insights
    getDeepInsightsAlerts: `/alerts/open`,
    getDeepInsightsAllAlerts: `/alerts`,
    deepInsightsChatCompletions: `/chat`,
    deepInsightsRegenerate: `/chat/regenerate`,
    deepInsightsSession: `/sessions`,
    updateDeepInsightsSession: `/sessions/update`,
    getDeepInsightsUserConversation: `/conversation`,
    getDeepInsightsConnectors: `/connectors`,
    deepInsightsFeedback: `/feedback`,
    deepInsightsSpeechTranscribe: `/speech/transcribe`,
    deepInsightsSpeechTTS: `/speech/tts/stream`,
    deepInsightsPlaybookRun: `/playbooks/{playbook_id}/run`,

    // Talent Pulse 360
    talentPulseChatCompletions: `/chat/completions`,
    getTalentPulseHistoryList: `/fetch-user-threads`,
    getTalentPulseUserConversation: `/fetch-conversation`,
    updateTalentPulseUserThread: `/update-user-thread`,
    talentPulseFeedback: `/feedback`,
    talentPulseSpeechTranscribe: `/speech/transcribe`,
    talentPulseSpeechTTS: `/speech/tts/stream`,
    talentPulseChatStop: `/chat/stop`,
    talentPulseCitationDownload: `/transcript/download`,
    talentPulseChatConsent: `/chat/consent`,

    getTalentPulseProfiles: `/profiles`,
    getTalentPulseProfileFilters: `/profiles/filters`,
    getTalentPulseProfileDetail: `/profiles/{id}`,

    // Talent Pulse Admin
    talentPulseAdminOptions: `/admin/options`,
    talentPulseAdminFiles: `/admin/files`,
    talentPulseAdminFileUpload: `/admin/files/upload`,
    talentPulseAdminDownload: `/admin/download`,

    // Talent Pulse Survey
    talentPulseSurveys: `/surveys`,
    talentPulseSurveySend: `/surveys/send`,
    talentPulseSurveySends: `/surveys/sends`,
    talentPulseSurveyUsers: `/surveys/users`,
    talentPulseSurveyStatus: `/surveys/{survey_send_id}/status`,
    talentPulseSurveyAnalyse: `/surveys/{survey_send_id}/analyse`,
    talentPulseSurveyDashboard: `/surveys/{survey_send_id}/dashboard`,
    talentPulseSurveyCardsData: `/surveys/{survey_send_id}/cards/{survey_type}`,
    talentPulseSurveyAction: `/surveys/{survey_send_id}/actions`,
};

export default API_ENDPOINTS;
